import React from 'react';
import './index.css'

interface IndicatorChipProps {
  label: React.ReactElement | string,
  outlined?: boolean,
  iconDecoration?: any,
  textColor?: string,
  bgColor?: string
}

const IndicatorChip: React.FC<IndicatorChipProps> = ({ label, iconDecoration }) => {

  return (
    <div className='chip-indicator'>
      {iconDecoration && (
        <div className='chip-indicator_icon'>
          {iconDecoration}
        </div>
      )}
      <div className='chip-indicator_label'>{label}</div>

    </div>
  );
}

export default IndicatorChip;